export default {
    props: {
        modalId: {
            default(){
                return _.uniqueId( 'modal_' );
            },
            type: String
        },

        modelId: {
            type: String,
            default(){
                return null;
            },
        }
    },

    created(){
        this.init();
    },

    data(){
        let defaultData = this.getDefaultData();
        let modelData = this.getModelData();

        return _.defaults( modelData, defaultData );
    },

    computed: {
        //Override
        resourceKey(){
            return 'Model';
        },

        saveValidationKey(){
            return 'model'
        },

        url(){
            if( this.model.id ){
                return '/api/models/' + this.model.id;
            }
            else {
                return '/api/models';
            }
        },
    },

    watch: {
        modelId(){
            if( this.modelId ){
                this.init();
            }
            else {
                this.resetData();
            }
        }
    },

    methods: {
        // Overrides
        /**
         * A hook that runs before a save takes place. If a promise is returned the hook will await its result
         *
         * @returns {Promise<void>|null}
         */
        beforeSave(){
            return Promise.resolve();
        },

        /**
         * A hook that runs after a save takes place. If a promise is returned the hook will await its result
         *
         * @returns {Promise<void>|null}
         */
        afterSave(){
            return Promise.resolve();
        },

        beforeLoad(){
            return Promise.resolve();
        },

        afterLoad( loadResults ){
            return Promise.resolve();
        },

        getModelData(){
            return {};
        },

        setModel( response ){
            return this.$set( this, 'model', response.data[ this.resourceKey ] );
        },

        // Core
        getDefaultData(){
            return {
                closeOnSave: true,
                closeOnDelete: true,
                closeOnRestore: false,
                saveResponse: true,

                loading: true,

                model: {},
            };
        },

        saveModel(){
            return this.$validator.validateAll( this.saveValidationKey )
                .then( ( valid ) => {
                    if( valid ){
                        var promise = Promise.resolve();
                        this.loading = true;

                        let beforeSaveResult = this.beforeSave();
                        if( beforeSaveResult instanceof Promise ){
                            promise = promise.then( () => {
                                return beforeSaveResult;
                            } );
                        }

                        let saveData = {};
                        saveData[ this.resourceKey ] = this.model;

                        if( this.model.id ){
                            promise = promise.then( () => {
                                return axios.put( this.url, saveData );
                            } );
                        }
                        else {
                            promise = promise.then( () => {
                                return axios.post( this.url, saveData );
                            } );
                        }

                        return promise.then( ( result ) => {
                            if( !this.model.id ){
                                this.setModel( result );
                            }
                        } )
                            .then( () => {
                                let afterSaveResult = this.afterSave();
                                this.$emit( 'afterSave', this.model );

                                if( afterSaveResult instanceof Promise ){
                                    return afterSaveResult;
                                }
                            } )
                            .then( () => {
                                return this.init();
                            } )
                            .then( () => {
                                if( this.closeOnSave ){
                                    this.closeModal();
                                }

                                if( this.saveResponse ){
                                    let response = 'Save Successful';
                                    if( _.isString( this.saveResponse ) ){
                                        response = this.saveResponse;
                                    }

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: response,
                                    } );
                                }
                            } )
                            .finally( () => {
                                this.loading = false;
                            } )
                            .catch( ( err ) => {
                                return this.$root.handleErrors( err, this.saveValidationKey );
                            } );
                    }
                } );
        },

        deleteModel(){
            this.loading = true;

            return axios.delete( this.url )
                .then( () => {
                    this.$emit( 'afterSave' );

                    if( this.closeOnDelete ){
                        this.closeModal();
                    }

                    this.$notify( {
                        type: 'success',
                        placement: 'top-left',
                        title: 'Delete Successful',
                    } );

                    return this.init();
                } )
                .finally( () => {
                    this.loading = false;
                } )
                .catch( ( err ) => {
                    return this.$root.handleErrors( err, this.saveValidationKey );
                } );
        },

        restoreModel(){
            this.loading = true;

            return axios.put( this.url + '/restore' )
                .then( () => {
                    this.$emit( 'afterSave' );

                    if( this.closeOnRestore ){
                        this.closeModal();
                    }

                    this.$notify( {
                        type: 'success',
                        placement: 'top-left',
                        title: 'Restore Successful',
                    } );

                    return this.init();
                } )
                .finally( () => {
                    this.loading = false;
                } )
                .catch( ( err ) => {
                    return this.$root.handleErrors( err, this.saveValidationKey );
                } );
        },

        load(){
            return axios.get( this.url )
                .then( ( response ) => {
                    return this.setModel( response );
                } );
        },

        init(){
            this.loading = true;

            return this.beforeLoad()
                .then( () => {
                    if( this.modelId ){
                        this.model.id = this.modelId;
                    }

                    if( this.model.id ){
                        return this.load();
                    }
                } )
                .then( ( loadResults ) => {
                    return this.afterLoad( loadResults );
                } )
                .finally( () => {
                    this.loading = false;
                } )
                .catch( this.$root.handleErrors );
        },

        beforeClose(){
            if( !this.modelId ){
                this.resetData();
            }
        },

        closeModal(){
            this.$modal.hide( this.modalId );
        },

        openModal(){
            this.$modal.show( this.modalId );
        },

        resetData(){
            let defaultData = this.getDefaultData();
            let modelData = this.getModelData();

            Object.assign( this.$data, _.merge( modelData, defaultData ) );

            this.$nextTick( () => {
                this.init();
            } );
        },
    }
};